import React from 'react'
import StyleSheet from 'styles'
import Typography from '@material-ui/core/Typography'
import SizeIcon from '@material-ui/icons/SettingsEthernet'
import { Progress } from './Progress'
import { FlexDataItem } from 'components/FlexDataView'
import {NumberDisplay} from 'components/numbers'
import {FormattedMessage} from 'react-intl'

export default props => {

  const isEquity = props.allocation.dealSheet.typeOfIssuance === 'equity'
  const ticker = isEquity ? props.allocation.currency.code : props.allocation.ticker || 'Unit';

  return <FlexDataItem size="large">
    <div className={styles.columns}>
      <div>
        <Typography variant='subtitle1'><SizeIcon /><FormattedMessage id="allocation.section.amount" /></Typography>
        <dl>
          { !isEquity && <React.Fragment>
            <dt><FormattedMessage id="allocation.section.amount.amount_label" /></dt>
            <dd><NumberDisplay suffix={ticker}>{props.allocation.amount}</NumberDisplay></dd>
          </React.Fragment> }

          <dt><FormattedMessage id="allocation.section.amount.value_label" /></dt>
          <dd>
            <NumberDisplay prefix={props.allocation.currency.prefix}>{props.allocation.value}</NumberDisplay> {props.allocation.currency.code}
          </dd>
        </dl>
      </div>
      <div>
        <Progress total={props.allocation.amount} claimed={props.allocation.amountClaimed} ticker={ticker} progressClassName={styles.progressBar} showKey />
      </div>
    </div>
  </FlexDataItem>
}

const styles = StyleSheet({
  columns: {
    display: 'flex',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
    margin: -10,
    '& > div': {
      flex: 1,
      margin: 10,
      minWidth: 300
    },
  },
  progressBar: {
    margin: [-5, 15],
    width: 'calc(100% - 30px)'
  },
  ellipsis: {
    textOverflow: 'ellipsis',
    maxWidth: 80,
    overflow: 'hidden',
    display: 'inline-block',
    verticalAlign: 'bottom'
  },
})